import featured from "@src/app/assets/featured.avif";
import OpinionCard from "@src/app/components/ArticleCard/OpinionCard";
import VerticalCard from "@src/app/components/ArticleCard/VerticalCard";
import EmblaArticleSlider, {
  EmblaArticleSliderLinks,
} from "@src/app/components/ArticleSlider/EmblaArticleSlider";
import CustomCarousel, {
  CarouselEmblaLinks,
} from "@src/app/components/Carousel/CarouselEmbla";
import { createMetaTags } from "@src/app/components/MetaTags/MetaTags";
import SectionContainer from "@src/app/components/SectionContainer";
import VideoStrip from "@src/app/components/VideoStrip";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";
import type { LinksFunction, MetaFunction } from "react-router";

import { fetchHomePageData } from "./Home.server";

export const loader = fetchHomePageData;

export const meta: MetaFunction = () => createMetaTags();
export const links: LinksFunction = () => [
  ...CarouselEmblaLinks(),
  ...EmblaArticleSliderLinks(),
];

export default function HomePage() {
  const {
    goodReadsArticles,
    // topArticles,
    heroArticles,
    highLightArticles,
    overviewArticles,
    perspectiveArticles,
    videoArticles = [],
  } = useRouteResponse("homePage");

  return (
    <div className="bg-secondary pb-[40px]">
      {/* PRD: if there are less than 3 articles. And display only the first 5 if there are more than 5 articles */}
      <CustomCarousel articles={heroArticles} />

      {/* 视频 */}
      <VideoStrip articles={videoArticles} />

      <div className="mx-auto box-content max-w-[1200px] lg:flex lg:px-[24px] ">
        <div className="w-full flex-1">
          {/* 新闻 */}
          {overviewArticles.length > 0 && (
            <SectionContainer title="新闻" more="/overview" testId="overview">
              <div className="w-full lg:grid lg:grid-cols-12">
                {overviewArticles.map((article) => (
                  <VerticalCard
                    article={article}
                    className="col-span-12 lg:col-span-3"
                    key={article.id}
                    testId={article.id}
                  />
                ))}
              </div>
            </SectionContainer>
          )}

          {/* 特写 */}
          {goodReadsArticles.length > 0 && (
            <SectionContainer
              title="特写"
              more="/good-reads"
              testId="good-reads"
            >
              <div className="w-full lg:grid lg:grid-cols-12">
                {goodReadsArticles.map((article) => (
                  <VerticalCard
                    article={article}
                    className="col-span-12 lg:col-span-3"
                    key={article.id}
                    testId={article.id}
                  />
                ))}
              </div>
            </SectionContainer>
          )}
        </div>
        {/* Top Articles 最多点击: hide for future usage */}
        {/* <div>
          <NumberedCardContainer
            className="mx-auto w-full px-3 py-4 lg:box-content lg:w-[300px]"
            title="最多点击"
            list={topArticles}
            testId="top"
          />

          <GoogleAd
            className="box-border min-w-max px-3 py-4"
            type={GoogleAdTypeEnum.IMU2}
          />
        </div> */}
      </div>

      {/* 精选 */}
      {highLightArticles.length > 0 && (
        <SectionContainer
          className="lg:px-[24px] lg:pb-[16px]"
          theme="dark"
          title="精选"
          bgImg={featured}
          testId="highlight"
        >
          <EmblaArticleSlider>
            {highLightArticles.map((article) => (
              <VerticalCard
                key={article.id}
                article={article}
                className="col-span-12 lg:col-span-3"
                testId={article.id}
              />
            ))}
          </EmblaArticleSlider>
        </SectionContainer>
      )}

      {/* 观点 */}
      {perspectiveArticles.length > 0 && (
        <SectionContainer
          className="lg:px-[24px]"
          title="观点"
          more="/perspective"
          testId="perspective"
        >
          <EmblaArticleSlider>
            {perspectiveArticles.map((article) => (
              <OpinionCard
                article={article}
                className="col-span-12 grid lg:col-span-3 lg:inline-block"
                key={article.id}
                testId={article.id}
              />
            ))}
          </EmblaArticleSlider>
        </SectionContainer>
      )}
    </div>
  );
}
